import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react"; //  our custom components

import ButtonMenu from "../../core/button-menu";
import IsInvertedProvider from "../is-inverted-provider";
var ContentCardActions = createComponent({
  displayName: 'ContentCardActionsCmp',
  propTypes: {
    isInverted: PropTypes.bool
  },
  defaultProps: {
    isInverted: false
  },
  render: function render(p) {
    var _children = p.children ? _.isArray(p.children) ? p.children : [p.children] : undefined;

    return p.children ? /*#__PURE__*/React.createElement(IsInvertedProvider, {
      isInverted: p.isInverted
    }, /*#__PURE__*/React.createElement("div", {
      className: "content-card-actions"
    }, /*#__PURE__*/React.createElement("div", {
      className: "content-card-actions__inner"
    }, /*#__PURE__*/React.isValidElement(p.children) ? _children : /*#__PURE__*/React.createElement(ButtonMenu, {
      items: _children
    })))) : null;
  }
});
export default ContentCardActions;
//# sourceMappingURL=content-card-actions.js.map